// extracted by mini-css-extract-plugin
export default {"heading":"ServicesPageContent_heading__LhV0V","smallTextSize":"ServicesPageContent_smallTextSize__dsnKU","mediumTextSize":"ServicesPageContent_mediumTextSize__F9Br+"};